var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-bot"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.pageSize,"total":_vm.pageCount,"pager-count":5},on:{"current-change":_vm.changePageClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }